/**
 * Builds a new instance of the YouTubeEmbed component.
 * @module YouTubeEmbed
 * @constructor
 */

/** @lends module:YouTubeEmbed */
function YouTubeEmbed (scope, util, element, params, renderer) {
    var that = this;
    that.attribute = 'data-stry-youtube-embed';

    /*  Catch instantiation errors  */
    if (!scope && !util && !element && !params) { return; }  //  Registration condition
    else {
        if (!scope) { console.error('StoryStream -> Accordion -> No scope provided.'); return; }
        if (!util) { console.error('StoryStream -> Accordion -> No util available.'); return; }
        if (!element) { console.error('StoryStream -> Accordion -> No element provided.'); return; }
        if (!params) { console.error('StoryStream -> Accordion -> No params provided.'); return; }
    }
    /*  End  */

    that.elem = element;
    that.template_url = '/wp-content/themes/lg_k/template-parts/components/youtube-embed.html';
    that.uid = params.uid;
    that.yt_player = undefined;
    that.yt_playlist_id = undefined;
    that.yt_playlist_index = undefined;
    that.yt_ready = false;
    that.yt_video_id = undefined;


    /**
     * Funnel all events through this method and distribute.
     * @memberof YouTubeEmbed
     * @function handleEvent
     * @param {object} e - Event data.
     * @inner
     */
    var handleEvent = function(e, params) {
        var type = e.type ? e.type : (e.html ? 'renderer' : false);
        switch(type) {
            case 'load':

                //  YoutTube API is ready
                if (typeof YT !== 'undefined') {
                    that.yt_ready = true;
                }

                break;
            case 'renderer':

                whenLightBoxTemplateHasLoaded(e.html);

                break;
            case 'viewport.click':

                //  Open the embeded player
                if (e.detail.action === 'click.youtube.embed') {

                    //  Take over if YouTube is ready,
                    //  otherwise just let the anchor link work as normal (opens video in new tab)
                    if (that.yt_ready) {
                        var target = e.detail.e.target;
                        var video_url = target.getAttribute('href');

                        //  Prevent link opening
                        e.detail.e.preventDefault();

                        //  Play the video as an embed
                        whenPlaybackRequested(video_url);
                    }
                }

                //  Close the embeded player
                if (e.detail.action === 'click.youtube.close') {

                    whenExitVideoRequested();
                }

                break;
            case 'webkitTransitionEnd':
            case 'msTransitionEnd':
            case 'transitionend':

                //  Remove event listeners
                e.target.removeEventListener('transitionend', handleEvent);
                e.target.removeEventListener('msTransitionEnd', handleEvent);
                e.target.removeEventListener('webkitTransitionEnd', handleEvent);

                //  Clear the component
                willRemovePlayerElements();

                break;
        }
    };


    /**
     * Funnel all YouTube API events through this function.
     * @memberof YouTubeEmbed
     * @function handleYT
     * @param {object} e - Event data.
     * @inner
     */
    var handleYT = function(e) {
        switch(e.data) {
            case 0:     //  Ended

                //  For single videos close the embed when finshed
                if (that.yt_video_id) {
                    whenExitVideoRequested();
                }

                //  For playlists wait until the last video has finished before closing
                else if (that.yt_playlist_id) {

                    //  The current 'yt_playlist_index' will be less than the 'getPlaylistIndex()'' value until the last video.
                    if (that.yt_playlist_index === that.yt_player.getPlaylistIndex()) {
                        whenExitVideoRequested();
                    }
                }

                break;
            case 1:     //  Playing

                //  Store the current playlist index
                if (that.yt_playlist_id) {
                    that.yt_playlist_index = that.yt_player.getPlaylistIndex();
                }

                break;
        }
    };


    /**
     * Function handles the last stages of removing the embed after animation is complete.
     * @memberof YouTubeEmbed
     * @function willRemovePlayerElements
     * @inner
     */
    var willRemovePlayerElements = function () {

        //  Clear the HTML
        that.elem.innerHTML = '';

        //  Remove closing animation class
        util.removeClass(that.elem, 'is-exited');

        //  Emit custom event to enable scrolling
        STRY.util.transmit(scope, 'view.scroll.enable');
    };


    /**
     * Function creates a new YouTube player instance based on embed component options.
     * @memberof YouTubeEmbed
     * @function willCreateYouTubePlayer
     * @inner
     */
    var willCreateYouTubePlayer = function () {
        var options = {
            height: '390',
            width: '640',
            events: {
                'onReady': handleYT,
                'onStateChange': handleYT
            }
        };

        //  Playlists
        if (that.yt_playlist_id) {
            options.playerVars = {
                autoplay: 1,
                listType:'playlist',
                list: 'PL7Cf2W8pJARrCveGdpfAMHIQY9x1aueWr'
            };
        }

        //  Single videos
        else if (that.yt_video_id) {
            options.videoId = that.yt_video_id;
            options.playerVars = {
                autoplay: 1
            };
        }

        //  Create new player instance
        that.yt_player = new YT.Player('yt_player', options);
    };


    /**
     * Function is fired when the component temp;ate has finished loading, render html, adds YouTube player and intro animation.
     * @memberof YouTubeEmbed
     * @function whenLightBoxTemplateHasLoaded
     * @param {string} html - Template html string to be added to this component.
     * @inner
     */
    var whenLightBoxTemplateHasLoaded = function (html) {

        //  Ensure the document is ready to render
        util.repaint.run(function () {

            //  Add element to document
            that.elem.innerHTML = html;

            //  Add YT player
            willCreateYouTubePlayer();

            //  Remove idle class to reveal UI
            util.repaint.run(function () {
                util.removeClass(that.elem, 'is-idle');
            });
        });
    };


    /**
     * Function is fired when the component template has finished loading, renders html, adds YouTube player and intro animation.
     * @memberof YouTubeEmbed
     * @function whenLightBoxTemplateHasLoaded
     * @param {string} video_url - The url of the YouTube video or playlist.
     * @inner
     */
    var whenPlaybackRequested = function (video_url) {
        var reggae;

        //  Single video ID
        if (video_url.indexOf('?v=') > -1) {

            //  Single video ID regex
            reggae = /[?&]v=([^#\&\?]+)/;

            //  Set video and playlist IDs
            that.yt_playlist_id = undefined;
            that.yt_video_id = video_url.match(reggae)[1];
        }

        //  Playlist ID
        else if (video_url.indexOf('list=') > -1) {

            //  Playlist ID regex
            reggae = /[?&]list=([^#\&\?]+)/;

            //  Set video and playlist IDs
            that.yt_playlist_id = video_url.match(reggae)[1];
            that.yt_video_id = undefined;
        }

        //  Ensure the embed is in idel mode to start off with
        util.addClass(that.elem, 'is-idle');

        //  Load view template
        renderer.compile({
            template: that.template_url,
            item: {
                video_url: video_url
            },
            callback: handleEvent
        });

        //  Emit custom event
        STRY.util.transmit(scope, 'view.scroll.disable');
    };



    /**
     * Function handles initial stages of embed teardown and triggering animation.
     * @memberof YouTubeEmbed
     * @function whenExitVideoRequested
     * @inner
     */
    var whenExitVideoRequested = function () {
        var lightbox = that.elem.getElementsByClassName('youtube-embed-lightbox')[0];

        //  Listen for when close animation has finished
        lightbox.addEventListener('transitionend', handleEvent);
        lightbox.addEventListener('msTransitionEnd', handleEvent);
        lightbox.addEventListener('webkitTransitionEnd', handleEvent);

        //  Remove YT player
        that.yt_player.destroy();

        //  Reset parameters
        that.yt_player = undefined;
        that.yt_playlist_id = undefined;
        that.yt_video_id = undefined;
        that.yt_playlist_index = undefined;

        //  Add closing animation class
        util.addClass(that.elem, 'is-exited');
    };


    /**
     * Function used to initialise the application.
     * @memberof YouTubeEmbed
     * @function init
     * @inner
     */
    var init = function () {

        //  Load YoutTube API
        if (typeof YT === 'undefined') {

            var yt = document.createElement('script');
            yt.setAttribute('src', 'https://www.youtube.com/iframe_api');
            document.body.appendChild(yt);
            yt.onload = handleEvent;
        }

        //  Listeners
        scope.addEventListener('viewport.click', handleEvent);
    };


    init();
    return that;
}
if (typeof module !== 'undefined' && exports !== null) {
    exports.YouTubeEmbed = YouTubeEmbed;
}
